import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "register-page" }
const _hoisted_2 = { class: "page-scroll-wrap" }
const _hoisted_3 = { class: "login-box" }
const _hoisted_4 = { class: "logo-wrap flex justify-center" }
const _hoisted_5 = { class: "form-title" }
const _hoisted_6 = { class: "input-label" }
const _hoisted_7 = { class: "input-box" }
const _hoisted_8 = { class: "input-label" }
const _hoisted_9 = { class: "input-box" }
const _hoisted_10 = { class: "input-label" }
const _hoisted_11 = { class: "input-box" }
const _hoisted_12 = { class: "input-label" }
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = { class: "input-box width-auto" }
const _hoisted_15 = { class: "input-box" }
const _hoisted_16 = { class: "extra-wrap" }

import { ref, reactive, computed, inject, onMounted } from 'vue';
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'
import md5 from 'js-md5';
import moment from 'moment';
import { useUserStore } from '@/store';
import TermsCheck from './components/TermsCheck';
import UploadId from './components/UploadId';
import DateSelect from '@/components/DateSelect.vue';
import { customRegister, saveInviteCode } from "@/api"; 


export default {
  __name: 'register',
  setup(__props) {

const UserHelper = inject('userHelper');

const MyToast = inject('myToast')

const route = useRoute();
const router = useRouter()
const { t } = useI18n()

const userStore = useUserStore();
 
const form = reactive({
  username: '',
  phone: '',
  password: '',
  confirmPassword: '',
  verifyCode: '',
  code: '',
  birthdayTimestamp: '',
  gamingVenue: '',
  address: '',
  income: '',
  occupation: '',
  idNumber: '',
  email: '',
  fullName: '',
  selfieImg: '',
})
const showPassword = ref(false)
const isTermsCheck = ref(false)
const endDate = moment().subtract(21, 'years')
const maxDate = ref(new Date(endDate.unix() * 1000))
const showDateSelect = ref(false);
const showSelfieUpload = ref(false);

const registerDisabled = computed(() => {
  return !isTermsCheck.value;
  // return form.phone.length < 10 || form.password.length < 6 || form.verifyCode.length < 6 || !isTermsCheck.value;
})

onMounted(() => {
  if(route.query?.code) {
    form.code = decodeURIComponent(decodeURIComponent(route.query?.code))
    saveCode();
  }
})

const saveCode = () => {
  saveInviteCode({
    code: form.code,
  }).then(res => {})
}

const doRegister = (values) => {
  console.log('submit', values);
  let postData = {
    ...values,
    password: md5(values.password),
    // selfieImg: form.selfieImg,
    // birthdayTimestamp: form.birthdayTimestamp || undefined,
    code: form.code,
    areaCode: '63',
  };
  customRegister(postData).then(res => {
    MyToast({ type: 'success', message: t('notify.registerSuccess') });
    let userData = res.data || {}
    userStore.setUserInfo(userData);
    UserHelper.init(userData);
    router.replace({ name: 'game' });
  });
}

const inputBlur = (e) => {
  let field = e.target.name
  if (field) {
    form[field] = form[field].replace(/ +/g, '');
  }
}

return (_ctx, _cache) => {
  const _component_HeaderBar = _resolveComponent("HeaderBar")
  const _component_NavBar = _resolveComponent("NavBar")
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_field = _resolveComponent("van-field")
  const _component_van_button = _resolveComponent("van-button")
  const _component_van_form = _resolveComponent("van-form")
  const _component_LicenseFooter = _resolveComponent("LicenseFooter")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HeaderBar),
    _createVNode(_component_NavBar, {
      title: _ctx.$t('common.register').toUpperCase()
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_van_image, {
            class: "logo-img",
            src: require('@/assets/img/common/login-title.png')
          }, null, 8, ["src"])
        ]),
        _createVNode(_component_van_form, {
          class: "input-form style1",
          onSubmit: doRegister
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('user.createAccount')), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('label.username')) + ":", 1),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_van_field, {
                modelValue: form.username,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((form.username) = $event)),
                name: "username",
                class: "input-field",
                placeholder: _ctx.$t('placeholder.username'),
                type: "text",
                rules: [
                { required: true, message: _ctx.$t('validate.required') },
                { pattern: /^[A-Za-z0-9]{6,13}$/, message: _ctx.$t('validate.default') }
              ],
                onBlur: inputBlur,
                maxlength: "13",
                clearable: ""
              }, null, 8, ["modelValue", "placeholder", "rules"])
            ]),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('label.pwd')) + ":", 1),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_van_field, {
                modelValue: form.password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((form.password) = $event)),
                name: "password",
                class: "input-field",
                type: !showPassword.value ? 'password' : 'text',
                rules: [
                { required: true, message: _ctx.$t('validate.required') },
                { pattern: /^[A-Za-z0-9]{6,12}$/, message: _ctx.$t('validate.default') }
              ],
                maxlength: "12",
                "right-icon": !showPassword.value ? 'eye' : 'closed-eye',
                onClickRightIcon: _cache[2] || (_cache[2] = $event => (showPassword.value=!showPassword.value)),
                onBlur: inputBlur,
                clearable: ""
              }, null, 8, ["modelValue", "type", "rules", "right-icon"])
            ]),
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('label.confirmPwd')) + ":", 1),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_van_field, {
                modelValue: form.confirmPassword,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((form.confirmPassword) = $event)),
                class: "input-field",
                type: !showPassword.value ? 'password' : 'text',
                rules: [
                { required: true, message: _ctx.$t('validate.required') },
                { pattern: /^[A-Za-z0-9]{6,12}$/, message: _ctx.$t('validate.default') },
                { validator: (val) => val === form.password, message: _ctx.$t('validate.pwdNotMatch') }
              ],
                maxlength: "12",
                "right-icon": !showPassword.value ? 'eye' : 'closed-eye',
                onClickRightIcon: _cache[4] || (_cache[4] = $event => (showPassword.value=!showPassword.value)),
                onBlur: inputBlur,
                clearable: ""
              }, null, 8, ["modelValue", "type", "rules", "right-icon"])
            ]),
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('label.mobilePhone')) + ":", 1),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_van_field, {
                  "model-value": "+63",
                  class: "input-prefix",
                  readonly: ""
                })
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_van_field, {
                  modelValue: form.phone,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((form.phone) = $event)),
                  name: "phone",
                  class: "input-field",
                  placeholder: _ctx.$t('placeholder.registerPhone'),
                  type: "digit",
                  rules: [{ required: true, message: _ctx.$t('validate.required') }],
                  onBlur: inputBlur,
                  maxlength: "10",
                  clearable: ""
                }, null, 8, ["modelValue", "placeholder", "rules"])
              ])
            ]),
            _createVNode(_unref(TermsCheck), {
              modelValue: isTermsCheck.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((isTermsCheck).value = $event))
            }, null, 8, ["modelValue"]),
            _withDirectives((_openBlock(), _createBlock(_component_van_button, {
              "native-type": "submit",
              class: "submit-btn",
              block: "",
              disabled: registerDisabled.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.register')), 1)
              ]),
              _: 1
            }, 8, ["disabled"])), [
              [_directive_audio]
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createTextVNode(_toDisplayString(_ctx.$t('user.haveAccount')) + " ", 1),
              _withDirectives((_openBlock(), _createElementBlock("span", {
                class: "highlight",
                onClick: _cache[7] || (_cache[7] = $event => (_unref(router).push({ name: 'login' })))
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t('common.login')), 1)
              ])), [
                [_directive_audio]
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_LicenseFooter)
      ])
    ]),
    (showDateSelect.value)
      ? (_openBlock(), _createBlock(DateSelect, {
          key: 0,
          modelValue: form.birthdayTimestamp,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((form.birthdayTimestamp) = $event)),
          max: maxDate.value,
          onOnClose: _cache[9] || (_cache[9] = $event => (showDateSelect.value = false))
        }, null, 8, ["modelValue", "max"]))
      : _createCommentVNode("", true),
    (showSelfieUpload.value)
      ? (_openBlock(), _createBlock(_unref(UploadId), {
          key: 1,
          modelValue: form.selfieImg,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((form.selfieImg) = $event)),
          onOnClose: _cache[11] || (_cache[11] = $event => (showSelfieUpload.value = false))
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}
}

}